var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"backimg"},[_c('img',{staticClass:"nodata-img",attrs:{"src":require("../../assets/image/nodata.png"),"alt":""}}),_c('p',[_vm._v("暂无数据")])])
}]

export { render, staticRenderFns }